import { ROUTES } from 'module/navigation/enums/routes.enums';
import { getPermissionAwareDetailLocation } from 'core/utils/permissionAwareNavigation';

export type BroadcastDetailLocationOptions = {
	canEdit?: boolean;
};

export const getBroadcastDetailLocation = (
	id: number | string,
	options: BroadcastDetailLocationOptions = {},
): { pathname: string } => {
	const { canEdit = false } = options;
	return getPermissionAwareDetailLocation({
		id,
		canEdit,
		editPath: ROUTES.EDIT_BROADCAST,
		viewPath: ROUTES.VIEW_BROADCAST,
	});
};
